<template><div><h1>VUX V2.2.1Rc.3 released</h1>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[fix] Fix no re-rendering when value is set to empty array. #1230</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] Support prop:confirm-text and prop:cancel-text. #1233</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.3 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.3-93.vue?6edf78a8